export default function InvoiceLine(data) {
    let invoiceLine = data || {};

    const productName = {
        facilita: "Ouverture dossier Facilita",
        setupfee1: "Ouverture dossier Anticipa",
        setupfee4: "Anticipa mensualité en 4 fois",
        setupfee6: "Anticipa mensualité en 6 fois",
        annual: "Suivi annuel",
        trainingday: "Journée de formation",
        assistrh: "Assist'RH"
    };

    let total = 0;

    switch (invoiceLine.type) {
        case "EtablissementReduced":
        case "EtablissementAnnualReduced":
        case "EtablissementTraining":
        case "PartnerTraining":
        case "UserAnnualReduced":
        case "AssistRh":
            total = invoiceLine.currentPrice * invoiceLine.quantity;

            break;

        case "BilledForEtablissementComission":
        case "BilledByEtablissementComission":
            total = (invoiceLine.currentPrice * invoiceLine.quantity * invoiceLine.comissionEtablissement) / 100;

            break;

        case "BilledForPartnerComission":
        case "BilledByPartnerComission":
            total = (invoiceLine.currentPrice * invoiceLine.quantity * invoiceLine.comissionPartner) / 100;

            break;

        default:
            break;
    }

    this.basePrice = invoiceLine.basePrice;
    this.billedByPartner = invoiceLine.billedByPartner;
    this.comissionEtablissement = invoiceLine.comissionEtablissement;
    this.comissionPartner = invoiceLine.comissionPartner;
    this.currentPrice = invoiceLine.currentPrice;
    this.endDate = new Date(invoiceLine.endDate);
    this.startDate = new Date(invoiceLine.startDate);
    this.invoiceId = invoiceLine.invoiceId;
    this.priceId = invoiceLine.priceId;
    this.product = productName[invoiceLine.product.toLowerCase()];
    this.quantity = invoiceLine.quantity;
    this.recipientId = invoiceLine.recipientId;
    this.recipientType = invoiceLine.recipientType;
    this.reductionEtablissement = invoiceLine.reductionEtablissement;
    this.reductionPartner = invoiceLine.reductionPartner;
    this.taxRate = invoiceLine.taxRate;
    this.taxRateId = invoiceLine.taxRateId;
    this.type = invoiceLine.type;
    this.totalPrice = total;

}